function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { addMonths } from 'date-fns';
import { useMemo } from 'react';
import { useIntl } from '../../../../../theme/i18n';
import { createActiveMonth, getFocusableDate } from '../../utilities';
import { useWeeks } from './useWeeks';
export var useMonth = props => {
  var {
    formatDate
  } = useIntl();
  var {
    monthsToAdd,
    activeMonth
  } = props;
  var target = monthsToAdd ? addMonths(activeMonth.date, monthsToAdd) : activeMonth.date;
  var month = useWeeks(_objectSpread(_objectSpread({}, props), {}, {
    activeMonth: createActiveMonth(target),
    onSelect: date => {
      var _props$setFocusableDa;

      props.onSelect(date);
      (_props$setFocusableDa = props.setFocusableDate) === null || _props$setFocusableDa === void 0 ? void 0 : _props$setFocusableDa.call(props, date);
    }
  }));
  var hasMonth = useMemo(() => month.some(week => week.some(day => day && !day.isDisabled)), [month]);
  var focusableDate = useMemo(() => getFocusableDate(month.flat(), monthsToAdd), [month, monthsToAdd]);

  var goToMonth = () => {
    var _props$setFocusableDa2;

    hasMonth && props.onSelect(target);
    (_props$setFocusableDa2 = props.setFocusableDate) === null || _props$setFocusableDa2 === void 0 ? void 0 : _props$setFocusableDa2.call(props, focusableDate);
  };

  var monthLabels = hasMonth ? {
    short: formatDate(target, {
      month: 'short'
    }),
    full: formatDate(target, {
      month: 'long'
    }),
    year: createActiveMonth(target).year
  } : undefined;
  return {
    month,
    hasMonth,
    monthLabels,
    goToMonth
  };
};
//# sourceMappingURL=useMonth.js.map